import React from 'react';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';
import PlanAllocationsOfAnnuitiesSlider from "../plan-allocations-of-annuities-slider";
import PlanWizardBalanceSlider from "../plan-wizard-balance-slider";

const PlanWizardPreferencesStep = ({state, handleChange, handleSliderChange, handleAnnuityTextBoxChange, handleBalancedSliderChange, handleBalancedLowerBoundsTextboxChange, handleBalancedUpperBoundsTextboxChange}) => {
    return (
        <div className={"plan-automation-wizard-preferences"}>
            <Typography variant="h6">Plan Preferences</Typography>
            <Typography variant="subtitle1">Plan Optimization Preferences</Typography>
            <FormControlLabel
                control={<Checkbox checked={state.stability} onChange={handleChange} name="stability" />}
                label="Stability - Optimize for Income Stability with lower market growth potential"
            />
            <FormControlLabel
                control={<Checkbox checked={state.accumulation} onChange={handleChange} name="accumulation" />}
                label="Accumulation - Maximize Portfolio Return with market volatility buffer"
            />
            <FormControlLabel
                control={<Checkbox checked={state.balanced} onChange={handleChange} name="balanced" />}
                label="Balanced - Mix of both Stability and Accumulation"
            />
            {state.balanced && <PlanWizardBalanceSlider value={state.balancedAllocation} handleSliderChange={handleBalancedSliderChange} handleLowerBoundTextBoxChange={handleBalancedLowerBoundsTextboxChange} handleUpperBoundTextBoxChange={handleBalancedUpperBoundsTextboxChange}/>}
            <PlanAllocationsOfAnnuitiesSlider value={state.annuitiesAllocation} handleSliderChange={handleSliderChange} handleAnnuityTextBoxChange={handleAnnuityTextBoxChange} />
        </div>
    );
};

export default PlanWizardPreferencesStep;
